import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const EventSource = ['unknown', 'user', 'plant', 'device'] as const;
export type TEventSource = (typeof EventSource)[number];

export type EventFilterRecord = {
  source: TEventSource;
  sourceId: string;
  label: string;
};

interface EventsFilterStore {
  sourceFilters: EventFilterRecord[];
  setSourceFilters: (sourceFilters: EventFilterRecord[]) => void;
  addSourceFilter: (filter: EventFilterRecord) => void;
  removeSourceFilter: (sourceId: string) => void;
  clearSourceFilters: () => void;
  hasSourceFilter: (sourceId: string) => boolean;
}

export const useEventsFilterStore = create<EventsFilterStore>()(
  devtools(
    (set, get) => ({
      sourceFilters: [],

      setSourceFilters: (sourceFilters: EventFilterRecord[]) =>
        set(() => ({
          sourceFilters,
        })),

      addSourceFilter: (filter) =>
        set((state) => {
          const exists = state.sourceFilters.some((f) => f.sourceId === filter.sourceId);
          if (exists) return state;

          return {
            sourceFilters: [...state.sourceFilters, filter],
          };
        }),

      removeSourceFilter: (sourceId) =>
        set((state) => ({
          sourceFilters: state.sourceFilters.filter((filter) => filter.sourceId !== sourceId),
        })),

      clearSourceFilters: () => set({ sourceFilters: [] }),

      hasSourceFilter: (sourceId) =>
        get().sourceFilters.some((filter) => filter.sourceId === sourceId),
    }),
    { name: 'ems-events-filter-store', version: '1.0.0' }
  )
);
